module.exports = __webpack_public_path__ + "static/media/SF-5-A.224b755f.mp3";